import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { Row, Col, Modal, ModalBody } from "reactstrap";
import RebelVillaTabForm from "./rebel-villa-tab-form";
import RebelVillaActivitiesTab from "./rebel-villa-activities-tab";
import RebelVillaBasicPricingTab from "./rebel-villa-basic-pricing-tab";
import { currencyOptions, Spacer } from "../../../utils/budget-tool-specific";
import { RebelColors, RebelCard, RebelButton, RebelAccentButton, RebelSecondaryButton, RebelIcon } from "../../../styles/rebel-experiences";
import { GetDB, generateGUID } from "../../../utils/database/firebase-budget-tool";
import { listenToDocument, updateDocumentProperty } from "../../../utils/firestore-functions";
import firebase from "firebase/compat/app";
import RebelFormInput from "../rebel-experiences/components/rebel-form-input";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const RebelVillaForm = (props) => {
    const [activeTab, setActiveTab] = useState('costs');
    const [devMode, setDevMode] = useState(false);

    const [data, setData] = useState(
        {   villaName: {value: "", invalid: false, required: true},
            location: {value: "", invalid: false, required: true},
            nearestAirport: {value: "", invalid: false, required: false},
            distanceFromAirport: {value: "", invalid: false, required: false},
            numberOfBedrooms: {value: 0, invalid: false, required: false},
            villaURL: {value: "", invalid: false, required: false},
            nearestCity: {value: "", invalid: false, required: false},
            distanceToCity: {value: "", invalid: false, required: false},
    })

    const budgetDB = GetDB();

    const [copyAlert, setCopyAlert] = useState(false);
    const saveVillaCostsRef = useRef(null);

    useEffect (() =>{
        var unsubscribe = listenToDocument(budgetDB, "rebelVillas", props.id, SetVillaContent);
        return unsubscribe;
    }, [])

    const validate = (value) => {
        if (value === undefined) {
            return true;
        } else {
            return false;
        }
    }

    const SetVillaContent = (villa) => {
        let newData = {...data};
        newData.villaName.value = villa.villaName;
        newData.location.value = villa.location;
        if (villa.nearestAirport !== undefined) newData.nearestAirport.value = villa.nearestAirport;
        if (villa.distanceFromAirport !== undefined) newData.distanceFromAirport.value = villa.distanceFromAirport;
        if (villa.numberOfBedrooms !== undefined) newData.numberOfBedrooms.value = villa.numberOfBedrooms;
        if (villa.villaURL !== undefined) newData.villaURL.value = villa.villaURL;
        if (villa.nearestCity !== undefined) newData.nearestCity.value = villa.nearestCity;
        if (villa.distanceToCity !== undefined) newData.distanceToCity.value = villa.distanceToCity;
        setData(newData);
    }

    const handleSubmit = (e, index) => {
        e.preventDefault();
        // focus on next input box
    }

    const updateVillaDetails = (id) => {
        updateDocumentProperty(budgetDB, "rebelVillas", id, "villaName", data.villaName.value);
        updateDocumentProperty(budgetDB, "rebelVillas", id, "location", data.location.value);
        updateDocumentProperty(budgetDB, "rebelVillas", id, "nearestAirport", data.nearestAirport.value);
        updateDocumentProperty(budgetDB, "rebelVillas", id, "distanceFromAirport", data.distanceFromAirport.value);
        updateDocumentProperty(budgetDB, "rebelVillas", id, "numberOfBedrooms", data.numberOfBedrooms.value);
        updateDocumentProperty(budgetDB, "rebelVillas", id, "villaURL", data.villaURL.value);
        updateDocumentProperty(budgetDB, "rebelVillas", id, "nearestCity", data.nearestCity.value);
        updateDocumentProperty(budgetDB, "rebelVillas", id, "distanceToCity", data.distanceToCity.value);
    }

    const saveAll = () => {
        updateVillaDetails(props.id);
        if (saveVillaCostsRef.current) {
            saveVillaCostsRef.current();
        }
    }

    const copyURL = () => {
        let url = window.location.href.replace("edit/", "");
        navigator.clipboard.writeText(url);
        setCopyAlert(!copyAlert);
    }


    return (
        <React.Fragment>
            <RebelModal isOpen={copyAlert} toggle={() => setCopyAlert(!copyAlert)}>
                <RebelModalBody toggle={() => setCopyAlert(!copyAlert)}>
                    <Row style={{display: "flex", alignItems: "center"}}>
                        <Col>
                            <p style={{margin: "0px", color: RebelColors.text}}>URL copied to clipboard!</p>
                        </Col>
                        <Col style={{display: "flex", justifyContent: "flex-end"}}>
                        <RebelButton style={{margin: "0px"}}onClick={() => setCopyAlert(!copyAlert)} >
                            Okay
                        </RebelButton>
                    </Col>
                    </Row>

                </RebelModalBody>
            </RebelModal>
            <BackButtonRow>
                <Col>
                    <RebelSecondaryButton onClick={() => window.location.href = '/budget-app/rebel-settings'}>
                        <FontAwesomeIcon icon={['fas', 'arrow-left']} style={{marginRight: "8px", color: RebelColors.gold}} />
                        Back to Properties
                    </RebelSecondaryButton>
                </Col>
            </BackButtonRow>
            <Row>
                <Col>
                    <RebelCard onSubmit={e => { handleSubmit(e, 1); }}>
                        {!props.client && <React.Fragment>
                        <Row>
                            <Col lg="3">
                                <RebelFormInput title="Property Name"
                                            id="villaName" data={data}
                                            setData={(x) => setData(x)}
                                            type="text"/>
                            </Col>
                            <Col lg="3">
                                <RebelFormInput title="Location"
                                    id="location" data={data}
                                    setData={(x) => setData(x)}
                                    type="text"/>
                            </Col>
                            <Col lg="2">
                                <RebelFormInput title="Bedrooms"
                                    id="numberOfBedrooms" data={data}
                                    setData={(x) => setData(x)}
                                    type="number"/>
                            </Col>
                            <Col lg="3">
                                <RebelFormInput title="Property URL"
                                    id="villaURL" data={data}
                                    setData={(x) => setData(x)}
                                    type="text"/>
                            </Col>
                            <Col lg="auto" style={{display: "flex", alignItems: "flex-end", paddingLeft: "0px", paddingBottom: "16px", gap: "12px"}}>
                                    <RebelAccentButton style={{margin: "0px"}} onClick={() => saveAll()}>Save</RebelAccentButton>
                                    <DevButton
                                        onClick={() => setDevMode(!devMode)}
                                        $active={devMode}
                                    >
                                        Dev
                                    </DevButton>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="3">
                                <RebelFormInput title="Nearest Airport"
                                    id="nearestAirport" data={data}
                                    setData={(x) => setData(x)}
                                    type="text"/>
                            </Col>
                            <Col lg="3">
                                <RebelFormInput title="Distance from Airport"
                                    id="distanceFromAirport" data={data}
                                    setData={(x) => setData(x)}
                                    type="text"/>
                            </Col>
                            <Col lg="3">
                                <RebelFormInput title="Nearest City"
                                    id="nearestCity" data={data}
                                    setData={(x) => setData(x)}
                                    type="text"/>
                            </Col>
                            <Col lg="3">
                                <RebelFormInput title="Distance to City"
                                    id="distanceToCity" data={data}
                                    setData={(x) => setData(x)}
                                    type="text"/>
                            </Col>
                        </Row>

                        {devMode && (
                            <DevInfoPanel>
                                <DevInfoTitle>Property Debug Info</DevInfoTitle>
                                <DevInfoRow>
                                    <DevInfoLabel>Property ID:</DevInfoLabel>
                                    <DevInfoValue>{props.id}</DevInfoValue>
                                </DevInfoRow>
                                <DevInfoRow>
                                    <DevInfoLabel>Database:</DevInfoLabel>
                                    <DevInfoValue>rebelVillas</DevInfoValue>
                                </DevInfoRow>
                                <DevInfoRow>
                                    <DevInfoLabel>Activities DB:</DevInfoLabel>
                                    <DevInfoValue>rebel-villa-activities (villa_id: {props.id})</DevInfoValue>
                                </DevInfoRow>
                            </DevInfoPanel>
                        )}

                        {/* Tab Navigation */}
                        <TabContainer>
                            <TabButton
                                active={activeTab === 'costs'}
                                onClick={() => setActiveTab('costs')}
                            >
                                <RebelIcon icon={['fas', 'dollar-sign']} />
                                Experience Data
                            </TabButton>
                            <TabButton
                                active={activeTab === 'activities'}
                                onClick={() => setActiveTab('activities')}
                            >
                                <RebelIcon icon={['fas', 'calendar-day']} />
                                Agenda Data
                            </TabButton>
                            <TabButton
                                active={activeTab === 'basicPricing'}
                                onClick={() => setActiveTab('basicPricing')}
                            >
                                <RebelIcon icon={['fas', 'tags']} />
                                Basic View Pricing
                            </TabButton>
                        </TabContainer>
                        </React.Fragment>}

                        {/* Tab Content */}
                        {activeTab === 'costs' && (
                            <RebelVillaTabForm
                                villaid={props.id}
                                updateVillaDetails={(x) => updateVillaDetails(x)}
                                setSaveVillaCostsRef={(fn) => saveVillaCostsRef.current = fn}/>
                        )}

                        {activeTab === 'activities' && (
                            <RebelVillaActivitiesTab
                                villaId={props.id}
                                villaName={data.villaName.value}
                                devMode={devMode}
                            />
                        )}

                        {activeTab === 'basicPricing' && (
                            <RebelVillaBasicPricingTab
                                villaId={props.id}
                            />
                        )}
                    </RebelCard>
                </Col>
            </Row>
        </React.Fragment>
    )

}
export default RebelVillaForm;

const RebelModal = styled(Modal)`
    .modal-content {
        background-color: ${RebelColors.surface};
        border: 1px solid ${RebelColors.border};
        color: ${RebelColors.text};
    }
`;

const RebelModalBody = styled(ModalBody)`
    background-color: ${RebelColors.surface};
    color: ${RebelColors.text};
`;

const BackButtonRow = styled(Row)`
    margin-bottom: 16px;
    padding-left: 15px;
    padding-right: 15px;
`;

const TabContainer = styled.div`
    display: flex;
    gap: 8px;
    margin-top: 24px;
    margin-bottom: 0;
    border-bottom: 2px solid ${RebelColors.border};
    padding-bottom: 0;
`;

const TabButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${props => props.active
        ? `linear-gradient(135deg, ${RebelColors.gold} 0%, #d4af37 100%)`
        : RebelColors.surfaceLight
    };
    color: ${props => props.active ? '#000000' : RebelColors.text};
    border: ${props => props.active
        ? `1px solid ${RebelColors.gold}`
        : `1px solid ${RebelColors.border}`
    };
    border-bottom: none;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 8px 8px 0 0;
    margin-bottom: -2px;

    svg {
        color: ${props => props.active ? '#000000' : RebelColors.gold};
        margin-right: 8px;
    }

    &:hover {
        background: ${props => props.active
            ? `linear-gradient(135deg, ${RebelColors.gold} 0%, #d4af37 100%)`
            : RebelColors.surfaceLight
        };
        color: ${props => props.active ? '#000000' : RebelColors.text};
        border-color: ${RebelColors.gold};
    }
`;

const DevButton = styled.button`
    background-color: ${props => props.$active ? '#4a4a4a' : 'transparent'};
    border: 1px solid #4a4a4a;
    border-radius: 4px;
    padding: 8px 12px;
    color: ${props => props.$active ? '#fff' : '#888'};
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: #4a4a4a;
        color: #fff;
    }
`;

const DevInfoPanel = styled.div`
    background-color: #1a1a2e;
    border: 1px solid #4a4a4a;
    border-radius: 8px;
    padding: 16px;
    margin: 20px 0;
    font-family: monospace;
`;

const DevInfoTitle = styled.div`
    color: #00d9ff;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const DevInfoRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    &:last-child {
        margin-bottom: 0;
    }
`;

const DevInfoLabel = styled.span`
    color: #888;
    font-size: 12px;
    min-width: 120px;
`;

const DevInfoValue = styled.span`
    color: #00ff88;
    font-size: 12px;
    background-color: #0a0a15;
    padding: 4px 8px;
    border-radius: 4px;
    user-select: all;
`;
